<template>
<v-text-field
  :value="value"
  :append-icon="isPasswordHidden ? 'mdi-eye' : 'mdi-eye-off'"
  :label="label"
  :name="inputName"
  :error-messages="errorMessages"
  :prepend-icon="prependIcon"
  :autofocus="autofocus"
    :type="isPasswordHidden ? 'password' : 'text'"
  autocomplete="off"
  @click:append="isPasswordHidden = !isPasswordHidden"
  @input="$emit('input', $event)"
/>
</template>

<script>
import i18n from '@/i18n/i18n-config';

export default {
  name: 'PasswordTextField',

  props: {
    value: {
      type: String,
      default: '',
    },
    inputName: {
      type: String,
      default: 'user-pw',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    prependIcon: {
      type: String,
      default: 'mdi-lock',
    },
    label: {
      type: String,
      default: i18n.t('password'),
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isPasswordHidden: true,
    };
  },

  mounted() {
    this.lazyLoadDisksFont();
  },

  methods: {
    lazyLoadDisksFont() {
      const styleTagId = 'disks-font';
      let styleTag = document.getElementById(styleTagId);
      if (styleTag) {
        return;
      }
      styleTag = document.createElement('style');
      styleTag.id = 'disks-font';
      styleTag.innerHTML = `@font-face {
        font-family: disks;
        src: url('./disks.ttf');
      }`;
      document.head.appendChild(styleTag);
    },
  },
};
</script>

<style>
.disk-font input {
  font-family: disks;
}
</style>
